import React from 'react';
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/core/styles';
import moment from "moment";
import clsx from "clsx";

import I18n from "../../../../../base/i18n.js";

import Tooltip from "../../../../../base/components/tooltip.js";

import InvestmentStatusEnum from "../../../../../enums/investment_status.js";
import InvestmentStatusDescriptionEnum from "../../../../../enums/investment_status_description.js";
import MoneyFormatter from "../../../../../utils/money_formatter.js";

const blockStyles = makeStyles(theme => ({
  root: {

  },
  tooltip: {
    fontSize: "14px",
    padding: "5px"
  },
  investmentStatus: {
    fontSize: "12px",
    color: theme.palette.greenMiddle,
    lineHeight: "1",
    marginTop: "-5px",
    padding: "8px 0",
    textAlign: "center",
    textTransform: "uppercase",
    ['@media (max-width: 768px)']: {
      padding: "5px",
      fontSize: "10px",
      lineHeight: "20px"
    },
  },
  applied: {
    background: "rgba(157, 198, 71, 0.2)"
  },
  paid: {
    background: "rgba(182, 123, 100, 0.2)"
  },
  paidBack: {
    background: theme.palette.grayBg
  },
  info: {
    marginTop: "15px",
    padding: "0 20px",
  },
  date: {
    fontSize: "12px",
    color: theme.palette.grayText,
    lineHeight: "1",
    marginBottom: "10px"
  },
  amountRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    lineHeight: "1.2",
    fontSize: "16px",
  },
  interest: {
    color: theme.palette.blueMain,
  },
}));

const ParticipantInfoBlock = (props) => {
  const { participant, className, classes : externalClasses = {}, showDateLabel = true } = props;
  const { investment } = participant || {};

  const classes = blockStyles();

  if(!participant || !investment) {
    return <React.Fragment />
  }

  // TODO: Nbsp
  let investmentText = undefined;
  if(investment.amount) {
    investmentText = `${I18n.t("shared.my_investment")}: ${MoneyFormatter.format(investment.amount)} ${I18n.t("currency.euro")}`;
  }
  else if(participant.desiredInvestmentAmount) {
    investmentText = `${I18n.t("shared.my_investment")}: ${MoneyFormatter.format(participant.desiredInvestmentAmount)} ${I18n.t("currency.euro")}`;
  }

  let interest = undefined;
  if(investment.interest) {
    interest = investment.interest;
  }
  else if(investment.calculatedInterest) {
    interest = investment.calculatedInterest;
  }

  let dateString = moment(investment.createdAt).format("DD.MM.YYYY");
  if(showDateLabel) {
    dateString = `${I18n.t("shared.investment_date")}: ${dateString}`
  }

  return (
    <div className = { clsx(classes.root, className) } >
      {
        investment.status &&
        <div className = { clsx({
          [classes.investmentStatus]: true,
          [externalClasses.investmentStatus]: true,
          [classes.applied]: investment.status === "applied",
          [classes.paid]: investment.status === "paid",
          [classes.paidBack]: investment.status === "paid_back"
        })}>
          <Tooltip content = {
            <div className = { classes.tooltip }>
              { InvestmentStatusDescriptionEnum.label(investment.status) }
            </div>
          }>
            { InvestmentStatusEnum.label(investment.status) }
          </Tooltip>
        </div>
      }
      <div className = { clsx(classes.info, externalClasses.info)  } >
        { investment.createdAt &&
          <div className = { clsx(classes.date, externalClasses.date) }>
            { dateString }
          </div>
        }
        <div className = { clsx(classes.amountRow, externalClasses.amountRow) }>
          {
            investmentText &&
            <span className = { clsx(classes.myInvestment, externalClasses.myInvestment) }>
              { investmentText }
            </span>
          }
          {
            interest &&
            <span className = { clsx(classes.interest, externalClasses.interest) }>
              { `+${MoneyFormatter.format(interest)} ${I18n.t("currency.euro")}`}
            </span>
          }
          </div>
      </div>
    </div>
  )
}

ParticipantInfoBlock.propTypes = {
  classes: PropTypes.shape({
    tooltip: PropTypes.string,
    info: PropTypes.string,
    investmentStatus: PropTypes.string,
    date: PropTypes.string,
    amountRow: PropTypes.string,
    myInvestment: PropTypes.string,
    interest: PropTypes.string
  }),
  showDateLabel: PropTypes.bool
}

export default ParticipantInfoBlock;
